import { MapToContext } from '@utils/objectWithDefault'

import IdGen from '@/utils/idGenerator/index'
const IdIterator = IdGen()

export class WroDraftProductQuantity {
  constructor (data) {
    const defaultdata = {
      amount: { val: 0, type: Number },
      lotNumber: { val: '', type: String },
      expirationDate: { val: '', type: String }
    }

    MapToContext(this, defaultdata, data)
  }
}

export class WroDraftProductQuantityWithId extends WroDraftProductQuantity {
  constructor (data) {
    super(data)
    this._id = IdIterator.next().value
  }
}

export class WroDraftProduct {
  constructor (data) {
    const defaultdata = {
      id: { val: 0, type: Number },
      name: { val: '', type: String },
      sku: { val: '', type: String },
      platform: {
        val: {
          id: { val: 0, type: Number },
          name: { val: '', type: String }
        },
        type: Object
      },
      isLotProduct: { val: false, type: Boolean },
      isDangerousGoods: { val: false, type: Boolean },
      sdsStatus: { val: 0, type: Number },
      barcode: { val: '', type: String },
      tariffCode: { val: '', type: String },
      customsValue: { val: 0, type: Number },
      description: { val: '', type: String },
      quantitiesToSend: { val: [], type: Array, subType: WroDraftProductQuantityWithId }
    }

    MapToContext(this, defaultdata, data)
    if (this.quantitiesToSend.length === 0) this.quantitiesToSend.push(new WroDraftProductQuantityWithId()) // each new draft product gets 1 by default
  }
}
